import { reactive, readonly } from "vue";

export interface LoadingState {
  active: boolean;
  label: string;
  fullscreen: boolean;
  count: number;
}

const state = reactive<LoadingState>({
  active: false,
  label: "Loading",
  fullscreen: true,
  count: 0,
});

let timer: number | null = null;

function show(label = "Loading", fullscreen = true) {
  state.count += 1;

  if (state.count === 1) {
    if (timer !== null) {
      clearTimeout(timer);
      timer = null;
    }

    timer = window.setTimeout(() => {
      state.active = true;
      state.label = label;
      state.fullscreen = fullscreen;
      timer = null;
    }, 120);
  }
}

function hide() {
  state.count = Math.max(0, state.count - 1);

  if (state.count === 0) {
    if (timer !== null) {
      clearTimeout(timer);
      timer = null;
    }
    state.active = false;
  }
}

function reset() {
  if (timer !== null) {
    clearTimeout(timer);
    timer = null;
  }
  state.count = 0;
  state.active = false;
  state.label = "Loading";
  state.fullscreen = true;
}

export function useLoadingStore() {
  return {
    state: readonly(state),
    show,
    hide,
    reset,
  };
}
